<template>
	<div class="sh-detail" :style="larghezza ? { width: larghezza + 'px' } : null">
		<div class="sh-head">
			<v-icon small class="mr-1">mdi-truck-outline</v-icon>
			<span class="sh-head-title">Ordine {{ item.OrderID }}</span>
			<span v-if="item.StatusOrder && item.StatusOrder.value" class="sh-muted ml-1">· {{ item.StatusOrder.value }}</span>
			<v-spacer></v-spacer>
			<v-btn x-small outlined color="primary" @click="$emit('order-tracking')"><v-icon left x-small>mdi-truck-fast-outline</v-icon>Tracking ordine</v-btn>
		</div>

		<div class="sh-body">
			<!-- prodotti -->
			<div class="sh-block sh-block--products">
				<div class="sh-section">Prodotti <span class="sh-muted">· {{ pezzi }} {{ pezzi === 1 ? 'pezzo' : 'pezzi' }}</span></div>
				<div v-if="!prodotti.length" class="sh-muted">Nessun prodotto</div>
				<div v-else class="sh-box">
					<div v-for="(p, i) in prodotti" :key="p._id || i" class="sh-line">
						<div class="sh-thumb">
							<img v-if="miniatura(p)" :src="miniatura(p)" alt="" loading="lazy" />
							<v-icon v-else small color="grey lighten-1">mdi-image-off-outline</v-icon>
						</div>
						<div class="sh-line-main">
							<div class="sh-line-title" :title="p.Title">{{ p.Title || 'Prodotto' }}</div>
							<div class="sh-line-sub">
								<span v-if="p.Attribute">{{ p.Attribute }} · </span>SKU {{ p.SKU || '—' }}<span v-if="p.ItemID"> · ID {{ p.ItemID }}</span>
							</div>
						</div>
						<div class="sh-line-qty">× <strong>{{ p.QuantityPurchased }}</strong></div>
						<div class="sh-line-price">{{ prezzo(p.TransactionPrice) }}</div>
					</div>
				</div>
			</div>

			<!-- indirizzo -->
			<div class="sh-block">
				<div class="sh-section">Indirizzo di spedizione</div>
				<div v-if="!indirizzo.length" class="sh-muted">Nessun indirizzo</div>
				<div v-else class="sh-box sh-address">
					<div v-for="r in indirizzo" :key="r.label" class="sh-addr-row">
						<v-icon x-small class="sh-addr-icon">{{ r.icona }}</v-icon>
						<span class="sh-addr-value" :class="{ 'font-weight-medium': r.label === 'Nome' }">{{ r.value }}</span>
						<v-btn x-small icon :title="'Copia ' + r.label.toLowerCase()" @click="copia(r.copia, r.label)">
							<v-icon x-small>{{ copiato === r.label ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
						</v-btn>
					</div>
					<v-btn x-small text color="primary" class="mt-1 px-1" @click="copia(indirizzoCompleto, 'tutto')">
						<v-icon left x-small>{{ copiato === 'tutto' ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>{{ copiato === 'tutto' ? 'Copiato' : 'Copia indirizzo completo' }}
					</v-btn>
				</div>
			</div>

			<!-- spedizioni -->
			<div class="sh-block sh-block--ships">
				<div class="sh-section d-flex align-center">
					<span>Spedizioni <span v-if="spedizioni.length" class="sh-muted">· {{ spedizioni.length }}</span></span>
					<v-spacer></v-spacer>
					<!-- ordine già spedito: si può ricreare la spedizione (sostituisce quella attuale, come prima dalla barra dei selezionati) -->
					<v-btn v-if="spedizioni.length" x-small depressed color="primary" title="Crea una nuova spedizione per questo ordine" @click="$emit('create')"><v-icon left x-small>mdi-plus</v-icon>Crea spedizione</v-btn>
				</div>
				<div v-if="!spedizioni.length" class="sh-box sh-empty-ship">
					<span class="sh-muted">Nessuna spedizione creata</span>
					<v-btn x-small depressed color="primary" @click="$emit('create')"><v-icon left x-small>mdi-plus</v-icon>Crea spedizione</v-btn>
				</div>
				<div v-else class="sh-box">
					<div v-for="(s, i) in spedizioni" :key="s._id || i" class="sh-ship">
						<img v-if="logoCorriere(s.Platform)" :src="logoCorriere(s.Platform)" :alt="s.Platform" class="sh-courier" />
						<span v-else class="sh-courier-name">{{ s.Platform }}</span>
						<div class="sh-ship-main">
							<div>
								<span class="sh-ship-status" :class="s.cron === false ? 'sh-ship-status--done' : 'sh-ship-status--live'" :title="s.cron === false ? 'Stato definitivo' : 'Stato seguito dal tracking automatico'">{{ s.status || '—' }}</span>
							</div>
							<div class="sh-line-sub">
								<a v-if="s.tracking" class="sh-tracking" @click="$emit('tracking', s)"><v-icon x-small color="primary">mdi-map-marker-path</v-icon> {{ s.tracking }}</a>
								<span v-else>Tracking non ancora disponibile</span>
							</div>
							<div class="sh-line-sub">
								<span v-if="s.created_at">Creata {{ s.created_at | moment('DD/MM/YYYY HH:mm') }}</span>
								<span v-if="s.updated_at"> · agg. {{ s.updated_at | moment('DD/MM/YYYY HH:mm') }}</span>
							</div>
						</div>
						<v-btn v-if="linklabel && s._id" x-small outlined color="primary" :href="linklabel + '&ship=' + s._id" title="Scarica la lettera di vettura">
							<v-icon left x-small>mdi-file-download-outline</v-icon>LDV
						</v-btn>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { immagineRiga } from '@/utils/immagineProdotto';

// dettaglio di un ordine da spedire: prodotti, indirizzo e tutte le spedizioni create
export default {
	name: 'ShippingDetail',
	props: {
		item: { type: Object, required: true },
		// URL base per scaricare l'etichetta (LDV) di una spedizione
		linklabel: { type: String, default: '' },
	},
	data() {
		// larghezza dell'area visibile della tabella (che qui scorre in orizzontale)
		return { copiato: '', larghezza: 0 };
	},
	computed: {
		prodotti() {
			return this.item.Items || [];
		},
		pezzi() {
			return this.prodotti.reduce((n, p) => n + (+p.QuantityPurchased || 0), 0);
		},
		spedizioni() {
			return this.item.shippings || [];
		},
		indirizzo() {
			const a = this.item.ShippingAddress || {};
			const citta = [a.PostalCode, a.CityName, a.StateOrProvince ? `(${a.StateOrProvince})` : ''].filter(Boolean).join(' ');
			return [
				{ label: 'Nome', icona: 'mdi-account-outline', value: a.Name, copia: a.Name },
				{ label: 'Indirizzo', icona: 'mdi-home-outline', value: [a.Street1, a.Street2].filter(Boolean).join(', '), copia: [a.Street1, a.Street2].filter(Boolean).join(' ') },
				{ label: 'Città', icona: 'mdi-city-variant-outline', value: citta, copia: a.CityName },
				{ label: 'CAP', icona: 'mdi-mailbox-outline', value: a.PostalCode, copia: a.PostalCode, nascosta: true },
				{ label: 'Nazione', icona: 'mdi-flag-outline', value: a.Country, copia: a.Country },
				{ label: 'Telefono', icona: 'mdi-phone-outline', value: a.Phone, copia: a.Phone },
			].filter(r => r.value && !r.nascosta);
		},
		indirizzoCompleto() {
			const a = this.item.ShippingAddress || {};
			return [a.Name, [a.Street1, a.Street2].filter(Boolean).join(' '), [a.PostalCode, a.CityName, a.StateOrProvince].filter(Boolean).join(' '), a.Country, a.Phone]
				.filter(Boolean)
				.join('\n');
		},
	},
	methods: {
		misura() {
			const td = this.$el.parentElement;
			const padding = td ? parseFloat(getComputedStyle(td).paddingLeft) + parseFloat(getComputedStyle(td).paddingRight) : 0;
			this.larghezza = Math.max(0, this.contenitore.clientWidth - padding);
		},
		miniatura(p) {
			return immagineRiga(p, this.item.itemsImages);
		},
		prezzo(v) {
			const n = Number(v);
			if (v === null || v === undefined || v === '' || isNaN(n)) return '—';
			return `${n.toFixed(2).replace('.', ',')} ${this.item.Currency || '€'}`;
		},
		logoCorriere(platform) {
			if (!platform) return '';
			try {
				return require(`@/assets/images/corrieri/${platform}.svg`);
			} catch (e) {
				return '';
			}
		},
		async copia(testo, chiave) {
			if (!testo) return;
			try {
				await navigator.clipboard.writeText(String(testo));
			} catch (e) {
				// contesto non sicuro (http): ripiego con textarea
				const t = document.createElement('textarea');
				t.value = String(testo);
				document.body.appendChild(t);
				t.select();
				document.execCommand('copy');
				document.body.removeChild(t);
			}
			this.copiato = chiave;
			clearTimeout(this.timerCopia);
			this.timerCopia = setTimeout(() => (this.copiato = ''), 1500);
		},
	},
	mounted() {
		// la tabella delle spedizioni e' piu' larga dello schermo: il dettaglio resta largo quanto
		// la parte visibile (e fermo con position: sticky), altrimenti le spedizioni finiscono fuori vista
		this.contenitore = this.$el.closest('.v-data-table__wrapper');
		// solo nella riga espansa del desktop (su mobile sta dentro la card, gia' larga giusta)
		if (!this.contenitore || this.$el.parentElement.tagName !== 'TD') return;
		this.misura();
		window.addEventListener('resize', this.misura);
	},
	beforeDestroy() {
		clearTimeout(this.timerCopia);
		window.removeEventListener('resize', this.misura);
	},
};
</script>

<style scoped>
.sh-detail {
	width: 100%;
	position: sticky;
	left: 16px;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	white-space: normal;
}
.sh-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.sh-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.sh-body {
	display: grid;
	grid-template-columns: minmax(0, 5fr) minmax(0, 3fr) minmax(0, 4fr);
	gap: 16px;
	padding: 12px;
}
.sh-section {
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #5f6b7a;
	margin-bottom: 6px;
}
.sh-muted {
	color: #5f6b7a;
	font-weight: 400;
	text-transform: none;
	letter-spacing: 0;
}
.sh-box {
	background: #fff;
	border: 1px solid #e1e7ef;
	border-radius: 8px;
	overflow: hidden;
}
.sh-line {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 10px;
	font-size: 14px;
}
.sh-line + .sh-line {
	border-top: 1px solid #eef2f7;
}
.sh-thumb {
	flex: 0 0 44px;
	width: 44px;
	height: 44px;
	border-radius: 6px;
	border: 1px solid #e1e7ef;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}
.sh-thumb img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.sh-line-main {
	flex: 1 1 auto;
	min-width: 0;
}
.sh-line-title {
	font-weight: 500;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.sh-line-sub {
	font-size: 12px;
	color: #5f6b7a;
	word-break: break-word;
}
.sh-line-qty {
	flex: 0 0 auto;
	white-space: nowrap;
}
.sh-line-price {
	flex: 0 0 80px;
	text-align: right;
	font-weight: 600;
	white-space: nowrap;
}
.sh-address {
	padding: 8px 10px;
}
.sh-addr-row {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	min-height: 26px;
}
.sh-addr-icon {
	color: #8a96a3 !important;
	flex: 0 0 auto;
}
.sh-addr-value {
	flex: 1 1 auto;
	min-width: 0;
	word-break: break-word;
}
.sh-empty-ship {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 10px;
	font-size: 14px;
}
.sh-ship {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 8px 10px;
	font-size: 14px;
}
.sh-ship + .sh-ship {
	border-top: 1px solid #eef2f7;
}
.sh-courier {
	flex: 0 0 auto;
	height: 26px;
	max-width: 72px;
	object-fit: contain;
}
.sh-courier-name {
	flex: 0 0 auto;
	font-weight: 600;
	font-size: 12px;
}
.sh-ship-main {
	flex: 1 1 auto;
	min-width: 0;
}
.sh-ship-status {
	font-weight: 600;
	font-size: 13px;
}
.sh-ship-status--done {
	color: #2e7d32;
}
.sh-ship-status--live {
	color: #01579b;
}
.sh-tracking {
	cursor: pointer;
}

@media (max-width: 1263px) {
	.sh-body {
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	}
	.sh-block--products {
		grid-column: 1 / -1;
	}
}
@media (max-width: 768px) {
	.sh-body {
		grid-template-columns: 1fr;
		padding: 8px;
	}
	.sh-line {
		flex-wrap: wrap;
		gap: 4px 10px;
	}
	.sh-line-main {
		flex-basis: calc(100% - 56px);
	}
	.sh-line-title {
		white-space: normal;
	}
	.sh-line-qty {
		flex: 1 1 auto;
		padding-left: 54px;
	}
	.sh-ship {
		flex-wrap: wrap;
	}
}
</style>
